"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Checkbox.scss");

require("./CheckboxDark.scss");

var _classNames = _interopRequireDefault(require("../../../util/classNames"));

var _CheckboxContext = require("./CheckboxContext");

var _reactstrap = require("reactstrap");

var _hooks = require("../../../util/hooks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ContextWrapper = function ContextWrapper() {
  try {
    var _useContext = (0, _react.useContext)(_CheckboxContext.Context),
        _useContext2 = _slicedToArray(_useContext, 8),
        onNewCheck = _useContext2[0],
        onRemoveCheck = _useContext2[1],
        notifyContext = _useContext2[2],
        onReorderChecks = _useContext2[4],
        checkedIds = _useContext2[6],
        onDisabledCheck = _useContext2[7];

    return [onNewCheck, onRemoveCheck, notifyContext, onReorderChecks, checkedIds, onDisabledCheck];
  } catch (e) {
    return [null, null, null, null, null, null];
  }
};

var Checkbox = function Checkbox(props) {
  var _useState = (0, _react.useState)(props.checked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var classes = (0, _classNames["default"])({
    disabled: props.disabled,
    checked: checked
  });

  var _ContextWrapper = ContextWrapper(),
      _ContextWrapper2 = _slicedToArray(_ContextWrapper, 6),
      onNewCheck = _ContextWrapper2[0],
      onRemoveCheck = _ContextWrapper2[1],
      notifyContext = _ContextWrapper2[2],
      onReorderChecks = _ContextWrapper2[3],
      checkedIds = _ContextWrapper2[4],
      onDisabledCheck = _ContextWrapper2[5];

  var key = props.id + 'key';
  (0, _react.useEffect)(function () {
    onMountAddToContext();
    return function () {
      return onUnMountRemoveFromContext();
    };
  }, []);

  var onMountAddToContext = function onMountAddToContext() {
    onNewCheck && onNewCheck(key, contextSetChecked, props.id, props.checked, props.disabled);
  };

  var onUnMountRemoveFromContext = function onUnMountRemoveFromContext() {
    onRemoveCheck && onRemoveCheck(key);
  };

  var contextSetChecked = function contextSetChecked(flag) {
    props.onChange(flag);
    setChecked(flag);
  };

  var onChange = function onChange(e) {
    e.stopPropagation();

    if (!props.disabled) {
      props.onChange(!checked);
      notifyContext && notifyContext(props.id, !checked, key);
      setChecked(!checked);
    }
  };

  (0, _react.useEffect)(function () {
    onReorderChecks && onReorderChecks(props.id, key);
  }, [props.id]);
  (0, _react.useEffect)(function () {
    if (checkedIds && checkedIds.includes(props.id) && !checked) {
      notifyContext && notifyContext(props.id, true, key);
      setChecked(true);
    }
  }, [checkedIds]);
  (0, _hooks.useUpdateEffect)(function () {
    notifyContext && notifyContext(props.id, props.checked, key);
    setChecked(props.checked);
  }, [props.checked]);
  (0, _react.useEffect)(function () {
    onDisabledCheck && onDisabledCheck(key, props.disabled);
  }, [props.disabled]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "checkbox-".concat(props.id),
    className: "gcl-check ".concat(props.className, " ").concat(classes),
    onClick: onChange,
    tabIndex: 1
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    disabled: props.disabled,
    id: "check-id-".concat(props.id),
    name: "check-".concat(props.id),
    checked: checked,
    onChange: props.onChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-check-item ".concat(props.captionPosition, " ").concat(props.assigned ? 'assigned' : '')
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon checkbox".concat(checked ? '-checked' : '', " ").concat(props.assigned ? 'assigned' : '')
  })), props.icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(props.icon, " ").concat(props.iconSize, " glc-check-icon")
  }), /*#__PURE__*/_react["default"].createElement("span", null, props.caption), props.tooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    delay: {
      show: 500,
      hide: 100
    },
    placement: "top",
    target: "checkbox-".concat(props.id),
    boundariesElement: "window"
  }, props.tooltip));
};

Checkbox.defaultProps = {
  onChange: function onChange() {},
  className: '',
  captionPosition: 'right',
  icon: '',
  iconSize: '',
  checked: false
};
Checkbox.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  caption: _propTypes["default"].string,
  captionPosition: _propTypes["default"].oneOf(['left', 'right']),
  checked: _propTypes["default"].bool.isRequired,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  icon: _propTypes["default"].string,
  iconSize: _propTypes["default"].oneOf(['small', 'large', '']),
  tooltip: _propTypes["default"].string
};
var _default = Checkbox;
exports["default"] = _default;